import React, { useState } from "react";
import ErrorBoundary from "../../../ErrorBoundary";
import { Input, } from "reactstrap";
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import Tooltip from 'react-tooltip-lite'

import InforedIcon from 'assets/images/infored.png' 
const CheckBoxCellRender = ({ rowData, columnName, updateRowValue,redflag }) => {
  //const value = rowData[columnName] === "Y" ? true : false;
  const value = columnName == "chargeAutomappingFlag" ? rowData[columnName] === "Y" ? true : false  : rowData[columnName] === "Y" ? false : true;
  const [check, setCheck] = useState(value)

  const handlerChange = (event) => {
    
    const { checked } = event.target;
    setCheck(checked);
    if(columnName == "chargeAutomappingFlag"){
      updateRowValue(checked ? "Y" : "N", columnName);
    }
    else{
      updateRowValue(check == true ? "Y" : "N", columnName);
    }
  }

  return (
    <div>
      <ErrorBoundary>
        <Input type="checkbox" name={columnName} checked={check} onChange={handlerChange} disabled={rowData.gcnSequenceNumber == 0 || rowData.accumulatorChargeAutomappingFlag == "N"}  style={rowData.gcnSequenceNumber == 0 ? {  cursor:"not-allowed"} : {cursor:"all-scroll"}} />
      &nbsp;
        <Tooltip content={(
                    <div className='tip-list-info'>
                      <p><span>
                      Due to current automapping status, mapping must be completed through the M icon in the main crosswalk</span></p>

                    </div>
                  )}
                    direction="down"
                    tagName="span"
                    className="target"
                    tipContentClassName=""
                    zIndex={99999}>
                    <span
                      className='cursor-pointer text-decoration-underline'
                    >
                      <img src={InforedIcon} hidden={!(redflag == 'redflagon')} />
                      {/* <FontAwesomeIcon  icon={faCircleInfo} fill="red"   hidden={!(redflag == 'redflagon')}/> */}
                      
                      {/* //<HoverImage src={EditIcon} hoverSrc={EditIcon} ></HoverImage> */}
                    </span>
                  </Tooltip>
      </ErrorBoundary>
    </div>
  );
};

export default CheckBoxCellRender;
